import { EquipmentsRepairFormInstance } from '../types';

export const validateForm = (
  instance: Partial<EquipmentsRepairFormInstance>
) => {
  let isValid = true;
  const errors: Partial<Record<keyof EquipmentsRepairFormInstance, string>> =
    {};

  if (!instance.service_data?.problem) {
    errors.problem = 'Не указан тип поломки';
    isValid = false;
  }
  if (!instance.service_data?.outlet?.id) {
    errors.outlet = 'Не указана ТТ';
    isValid = false;
  }
  if (!instance.service_data?.address) {
    errors.address = 'Не указан адрес';
    isValid = false;
  }

  return {
    isValid,
    errors,
  };
};
